module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedMedium.fb26a2e.eot";